import React from "react"
import PropTypes from "prop-types"
// Material Ui
import FormControl from "@material-ui/core/FormControl"
import InputLabel from "@material-ui/core/InputLabel"
import Select from "@material-ui/core/Select"

const SelectInput = (props) => {
  const { input, label, children, className } = props

  return (
    <FormControl variant="outlined" size="small" className={className}>
      <InputLabel id={`${input.name}-label`}>{label}</InputLabel>
      <Select labelId={`${input.name}-label`} id={input.name} {...input}>
        {children}
      </Select>
    </FormControl>
  )
}

SelectInput.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onDragStart: PropTypes.func,
    onDrop: PropTypes.func,
    onFocus: PropTypes.func,
    value: PropTypes.any
  }).isRequired,
  label: PropTypes.string,
  readonly: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  className: PropTypes.string
}
SelectInput.defaultProps = {
  label: undefined,
  readonly: false,
  children: [],
  className: undefined
}

export default SelectInput
